export default {"src":"/_next/static/media/organisationIcon.ac8d1065.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};